<template>
  <div class="news" style=" ">
    <h3 class="titles" style="margin-top: 10px;">News</h3>
    <div style="border: 3px solid #CCCCCC; width: 200px"></div>

    <div style="width: 100%;margin: auto">
      <p style="text-align: left; font-size: 20px; margin:5px">
        <b style="font-size: 25px;font-family: Arial">· 2024-12:  </b>
      </p>
      <p style="text-align:left; margin: 0px;margin-left: 20px;font-family: Arial">
        New Paper! Our database CancerSRT, a spatially resolved transcriptomics database for human cancers was published at Journal of Genetics and Genomics!
      </p>

      <p style="text-align: left; font-size: 20px; margin:5px">
        <b style="font-size: 25px;font-family: Arial">· 2024-09:  </b>
      </p>
      <p style="text-align:left; margin: 0px;margin-left: 20px;font-family: Arial">
        We are looking for creative and highly motivated students to join our group.
        If you want to discuss potential opportunities, contact us.
      </p>
      <p style="text-align: left; font-size: 20px; margin:5px">
        <b style="font-size: 25px;font-family: Arial">· 2024-09:  </b>
      </p>
      <p style="text-align:left; margin: 0px;margin-left: 20px;font-family: Arial">
        The lab welcomes new students Jianxing Zhang, Zhuoxin Yao, Zhipeng Tan and Rui Zhao.
      </p>
      <p style="text-align: left; font-size: 20px; margin:5px">
        <b style="font-size: 25px;font-family: Arial">· 2024-06:  </b>
      </p>
      <p style="text-align:left; margin: 0px;margin-left: 20px;font-family: Arial">
        Congratulations to Yuying Huo on being awarded the Excellent Master thesis of Beijing Jiaotong University.
      </p>
      <p style="text-align: left; font-size: 20px; margin:5px">
        <b style="font-size: 25px;font-family: Arial">· 2024-06:  </b>
      </p>
      <p style="text-align:left; margin: 0px;margin-left: 20px;font-family: Arial">
        Congratulations to Yuying Huo, Jiakang Wang and Mengnan Gao on their graduation with master's degrees.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News'
}
</script>

<style scoped>
.titles {
  color: #005BAC;
  text-align: left;
  margin: 20px 0 0 0;
  padding: 0;
  font-family: 'Arial';
  font-size: 28px
}
.subtitles {
  text-align: left;
  margin: 20px 0 0 50px;
  padding: 0;
}
.sub_subtitles{
  text-align: left;
  margin: 20px 0 0 100px;
  padding: 0;
}
.news {
  width: 1000px; 
  margin: auto;
}
@media screen and (max-width: 768px) {
  .news {
    width: 80%; 
    margin: auto;
  }
  .titles {
  color: #005BAC;
  text-align: left;
  margin: 20px 0 0 0;
  padding: 0;
  font-family: 'Arial';
  font-size: 27px
}
}
</style>



// WEBPACK FOOTER //
// src/components2/News.vue